import { defineComponent as _defineComponent } from 'vue';
import { ref, computed } from 'vue';
import { VContainer, VRow, VCol } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import DemoSection from '../../components/DemoSection.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosRadioDemo',
    setup(__props) {
        const radio1 = ref('1');
        const radio2 = ref('1');
        const radio3 = ref(null);
        const radio4 = ref('vue');
        const rules = computed(() => [(v) => !!v || 'Debes seleccionar una opción']);
        return { __sfc: true, radio1, radio2, radio3, radio4, rules, VContainer, VRow, VCol, CodePreview, DemoSection };
    }
});
